<template>
  <v-col
    :cols="width"
    v-on="getEvent"
    @contextmenu="onShowContextMenu"
    :class="
      evaluateClasses(
        classes,
        'pa-0 dr-grid-layout-column',
        isInEditorMode ? 'dr-grid-layout-column-editor-mode' : '',
        isSelectedColumn() ? 'dr-grid-layout-column-selected' : ''
      )"
  >
    <!--  Отрисовка кнопки удаления для колонок в панели свойств -->
    <portal to="action-buttons" v-if="isSelectedColumn()">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn :disabled="readonly" v-on="on" text color="error" @click="onDeleteColumn">
            <font-awesome-icon :icon="['fal', 'trash-alt']" size="lg" />
          </v-btn>
        </template>
        <span>{{ $t("vuetifyWidgets.common.remove") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn :disabled="readonly" v-on="on" text color="success" @click="onAddColumn">
            <font-awesome-icon :icon="['fal', 'plus']" size="lg" />
            <font-awesome-icon :icon="['fal', 'grip-vertical']" size="lg" />
          </v-btn>
        </template>
        <span>{{ $t("vuetifyWidgets.dr-grid-layout.addColumn") }}</span>
      </v-tooltip>
    </portal>

    <!-- Шапка -->
    <div v-if="isInEditorMode" :class="['dr-grid-layout-column-header']">
      <span>{{ model.Weight }}</span>
    </div>

    <!-- режим корректировки -->
    <draggable
      v-if="isInEditorMode"
      :class="['column-draggable-target', evaluateExpression(model.Class)]"
      :group="{ name: 'container', put: ['toolbox', 'container'] }"
      @add="onWidgetDraggableAdd"
      @update="onModelChanged"
      @change="onDraggableChanged"
      @start="onStartDraggable"
      :list="model.Widgets"
      :disabled="readonly"
      :swapThreshold="0.95"
      :emptyInsertThreshold="20"
    >
      <!-- Виджеты -->
      <component
        v-for="widget in model.Widgets || []"
        :key="widget.$ID"
        :parentsWidgets="currentListOfParentsWidgets"
        :is="widget.$Type"
        :readonly="readonly"
        :model="widget"
        @modelChanged="onModelChanged"
        @deleteComponent="onDeleteColumnComponent"
        @replaceComponent="onReplaceComponent"
      />
    </draggable>

    <!-- режим проигрывания -->
    <template v-else-if="isVisible" v-for="widget in model.Widgets">
      <component
        :key="widget.$ID"
        :is="widget.$Type"
        :dataSource="dataSource"
        :parentDataWidget="parentDataWidget"
        @callDataSourceAction="$emit('callDataSourceAction', $event)"
        :model="widget"
      />
    </template> 

    <!-- Контекстное меню -->
    <widgets-context-menu
      v-if="isInEditorMode"
      v-model="showContextMenu"
      :x="x"
      :y="y"
      :snippetCreatable="false"
      :widgetModel="model"
      @deleteComponent="onDeleteColumn"
      @pasteCopiedWidget="onPasteCopiedWidget"
      />
  </v-col>
</template>

<script>
import inputMixin from '../../mixins/input-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import mixin from '../../mixins/base-mixin'
import contextMenuMixin from '../../mixins/contextmenu-mixin'
import jsonPatchMixin from '../../mixins/jsonPatchMixin'

export default {
  name: 'dr-grid-layout-column',
  mixins: [mixin, inputMixin, contextMenuMixin, widgetsWrapperMixin, jsonPatchMixin],
  props: ['model'],
  data() {
    return {}
  },
  computed: {
    getEvent() {
      if (this.isInEditorMode) { 
        return { click: (event) => { 
          event.stopPropagation()
          this.selectComponent(this.model) 
        }}
      }
      return {}
    },
    width() {
      let value = ''
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          value = this.model.WeightOnMobile || this.model.Weight
          break
        case 'sm':
          value = this.model.WeightOnTablet || this.model.Weight
          break
        default:
          value = this.model.Weight
          break
      }
      return value
    }
  },
  methods: {
    onModelChanged() {
      this.$emit('modelChanged', this.model)
    },
    // Наведение на зону шапки или выход из зоны шапки колонки
    onMouseEnterLeave(isHover) {
      this.isHover = isHover
    },
    // Выбор колонки по клику на шапку
    isSelectedColumn() {
      return this.$store.state[this.stateName].selectedWidget == this.model
    },
    // Удаление компонента из колонки
    onDeleteColumnComponent(val) {
      this.model.Widgets = this.model.Widgets.filter((comp) => comp != val)
      this.$emit('modelChanged', this.model)
      this.widgetsHelper.setSelectedWidget(undefined)
    },
    onReplaceComponent({ oldModel, newModel }) {
      this.model.Widgets = this.model.Widgets.map((x) => {
        return x == oldModel ? newModel : x
      })
      this.$emit('modelChanged', this.model)
      this.widgetsHelper.setSelectedWidget(newModel)
    },
    // Удаление колонки
    onDeleteColumn() {
      this.$emit('deleteColumn', this.model)
    },
    // Добавление колонки
    onAddColumn() {
      this.$emit('addColumn')
    }
  }
}
</script>
